import { create } from 'zustand';

interface QuotePresenceStore {
  // The quote item the current user is actively interacting with (dialog,
  // menu) — a strong "I'm editing this" signal.
  activeItemId: string | null;
  // The quote item currently hovered — a weak fallback signal.
  hoveredItemId: string | null;
  // Navigation request: the quote item to scroll to (set when following a
  // collaborator from the presence stack; the product table consumes + clears).
  scrollToItemId: string | null;
  // The quote item to briefly outline (blue border) after a follow jump, so the
  // destination row is obvious. Cleared by a timer once the pulse has shown.
  highlightedItemId: string | null;
  setActiveItemId: (id: string | null) => void;
  setHoveredItemId: (id: string | null) => void;
  requestScrollToItem: (id: string | null) => void;
  setHighlightedItemId: (id: string | null) => void;
}

/**
 * Client-side presence state for the Quotes V2 details page. The
 * QuotePresenceBridge reads this and broadcasts the active/hovered quote item
 * as the member's Spaces location so collaborators see who's on which line.
 */
export const useQuotePresenceStore = create<QuotePresenceStore>(set => ({
  activeItemId: null,
  hoveredItemId: null,
  scrollToItemId: null,
  highlightedItemId: null,
  setActiveItemId: id => set({ activeItemId: id }),
  setHoveredItemId: id => set({ hoveredItemId: id }),
  requestScrollToItem: id => set({ scrollToItemId: id }),
  setHighlightedItemId: id => set({ highlightedItemId: id })
}));
